import diacritics from 'diacritics';
import moment from 'moment';
import queryString from 'query-string';
import UAParser from 'ua-parser-js';

export const range = length => [...Array(length).keys()];

export const normalize = value => diacritics.remove(value).toLowerCase();

export const camelize = str => {
    if (Array.isArray(str)) str = str.join(' ');
    return str.split(' ').map((word, index) => {
        if (index === 0) return word.toLowerCase();
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join('');
};

/**
 * @function
 * @template T
 * @param {T} obj
 * @param {keyof T} key
 */
export const formatMoney = (obj, key, minimumFractionDigits = 0, maximumFractionDigits = 0, useGrouping = true) => {
    return `${obj[`${key}Currency`]} ${obj[key].toLocaleString('es', {
        minimumFractionDigits,
        maximumFractionDigits,
        useGrouping,
    })}`;
};

/**
 * @function
 * @template T
 * @param {T} obj
 * @param {keyof T} key
 * @param {string} [currency='ARS'] - Currency code, defaults to ARS
 */

export const customCurrencyFormat = (obj, key, currency = 'ARS') => {
    return `${obj[key].toLocaleString('es', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: 'currency',
        useGrouping: true,
        currency,
        currencyDisplay: 'code',
    })}`;
};

export const isMobile = () => new UAParser().getResult().device.type === 'mobile';
export const toQueryString = (obj) => queryString.stringify(obj);
export const parseQueryString = (query) => queryString.parse(query);

export const checkPermission = (user, permissions) => {
    if (!Array.isArray(permissions)) permissions = [permissions];
    return permissions.every(codename => user.permissions[codename]);
};

export const isSupervisor = user => {
    // Determines if the user supervises at least one organization
    return user && user.isSupervisor;
};

export const isSessionSupervisor = user => {
    // Determines if the is a supervisor based on the current session organization
    return user && user.isSessionSupervisor;
};

export const editQueryParams = (field, location, history) => {
    const oldParams = parseQueryString(location.search) || {};
    const newParams = removeParam(field, oldParams);
    history.push({search: toQueryString(newParams)});
    return newParams;
};

export const removeParam = (field, oldParams) => {
    const keys = Object.keys(oldParams).filter(key => key !== field);
    let newParams = {};
    keys.forEach(key => newParams[key] = oldParams[key]);
    return newParams;
};

export const removeEmptyValues = (options) => {
    const keys = Object.keys(options).filter(key => options[key] !== '');
    let newParams = {};
    keys.forEach(key => newParams[key] = options[key]);
    return newParams;
};

export const addQueryParams = (params, history, location) => {
    const oldParams = parseQueryString(location.search);
    const querystring = removeEmptyValues({...oldParams, ...params});
    history.push({search: toQueryString({...querystring})});
};

export const getCurrentPage = (location) => {
    const {page} = parseQueryString(location.search) || {};
    return Number(page) || 0;
};

export const getPageFromQS = (oldParams, newParams) => {
    if (newParams['page'] === 0) return 0;
    if (!!newParams['page']) return newParams['page'];
    if (!!oldParams['page']) return oldParams['page'];
    return 0;
};

export const getMaxPage = (elements, pageSize) => {
    return !!elements ? (Math.ceil(elements / pageSize) - 1) : 0;
};

export const enableSessionOrganizationChange = (user) => {
    if (!user) return false;

    return isSupervisor(user) && checkPermission(user, 'useSystemAsSupervisedOrganization');
};

/** @param {string} date */
export function formatDateTime(date) {
    return moment(date).format('DD/MM/YYYY - HH:mm');
}

/** @param {string} date */
export function formatDate(date) {
    return moment(date).format('DD/MM/YYYY');
}

export function getVariationOptions(product) {
    return product.variations.map(variation => ({
        value: variation.id,
        label: variation.name,
    }));
}

export function getDefaultAddress(addressesData) {
    const address = addressesData.addresses && addressesData.addresses.find(address => {
        return address.isDefault === true;
    });
    if (address) return address.id;
    return undefined;
}



// WEBPACK FOOTER //
// ./core/utils.js